import ControlGroup from "./control-group";
import React, {useContext} from "react";
import {FormContext} from "../../index";
import classNames from "classnames";
import {prefixExpression} from "../utils";

export const buildField = (key, defaults, overrides, basePath) => {
    const override = overrides?.[key];
    if (override?.hidden === true) return null;

    const merged = {
        ...defaults,
        ...(override || {}),
    };

    if (typeof merged.showsWhen === "string") {
        merged.showsWhen = prefixExpression(merged.showsWhen, basePath);
    }

    if (key === "type" && override?.options && Array.isArray(override.options)) {
        merged.options = defaults.options?.filter((o) =>
            override.options.includes(o.value)
        );
    }

    return merged;
};

export default function VideoInput(props) {
    const formContext = useContext(FormContext);

    const parts = props.name.split(".");
    const basePath = parts.slice(0, -1).join(".");

    const overrides = props.fieldOptions || {};

    const fields = [
        buildField(
            "url",
            {
                label: "Video",
                description:
                    "Enter the URL of the video you want to display. Supports YouTube and Vimeo.",
                type: "text",
                name: `${props.name}.url`,
            },
            overrides,
            basePath
        ),
        buildField(
            "controls",
            {
                label: "Show Playback Controls",
                type: "switch",
                name: `${props.name}.controls`,
                value: false,
                flipLayout: true,
                small: true,
            },
            overrides,
            basePath
        ),
        buildField(
            "playing",
            {
                label: "Autoplay Video",
                type: "switch",
                name: `${props.name}.playing`,
                value: true,
                flipLayout: true,
                small: true,
            },
            overrides,
            basePath
        ),
        buildField(
            "looping",
            {
                label: "Loop Video",
                type: "switch",
                name: `${props.name}.looping`,
                value: true,
                flipLayout: true,
                small: true,
            },
            overrides,
            basePath
        ),
    ].filter(Boolean);

    const showEdit = props.editing && !props.system;

    return (
        <div>
            {showEdit ? (
                <div className={classNames("block w-full")}>
                    <span
                        className="text-xs font-medium text-primary-500 leading-5 cursor-pointer hover:underline"
                        onClick={props.onEditFieldSettings}
                    >Edit</span>
                </div>
            ) : null}
            <ControlGroup{...props} className="!space-y-5 !block" fields={fields}/>
        </div>
    );
}